import { ClipLoader } from "react-spinners";

export default function Spinner({ className, size = 16, color = "#36d7b7" }) {
  return <ClipLoader className={className} color={color} size={size} />;
}
